import React, {useRef, useEffect} from 'react';
import {getFooter} from '~/Configuration/themeConfig';

const Footer = () => {
  const footerRef = useRef(null);
  const {
    language = ''
  } = window.sphinxEnosThemeHeader || {};

  let copyrightLanguage = '';
  if (language === 'en' || language === 'en_us' || language === 'en_US' || language === 'EN_US') {
    copyrightLanguage = 'en';
  } else {
    copyrightLanguage = 'zh_CN';
  }

  const footer = getFooter();

  useEffect(() => {
    if (footerRef.current) {
      footerRef.current.innerHTML = footer[copyrightLanguage];
    }
  }, []);

  return (
    <footer className='footer'>
      <div className='warp'>
        <div className='copyright' ref={footerRef} />
      </div>
    </footer>
  );
};

export default Footer;
